import { type PropsWithChildren, useMemo } from "react"
import { RequestErrorMessageAlert } from "@/components/molecules/RequestErrorMessageAlert"
import { ActionsAccept } from "./components/atoms/ActionsAccept"
import { ActionsCancel } from "./components/atoms/ActionsCancel"
import { ActionsSkip } from "./components/atoms/ActionsSkip"
import { ActionsProvider } from "./contexts/actions-context"

export interface ActionsProps extends PropsWithChildren {
    loading?: boolean
    step?: boolean
}

export function Actions({ children, loading = false, step = false }: ActionsProps) {
    const value = useMemo(() => ({ loading, step }), [loading, step])

    return <ActionsProvider value={value}>{children}</ActionsProvider>
}

Actions.Accept = ActionsAccept
Actions.Cancel = ActionsCancel
Actions.Error = RequestErrorMessageAlert
Actions.Skip = ActionsSkip
